import React, { useState, useEffect } from 'react'
import Header from "components/Headers/Header.js";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import axios from 'axios'
import { Form } from 'react-bootstrap';
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, Alert, CardFooter, Button, CardTitle } from "reactstrap";
import { format } from 'date-fns'; 
import { MapContainer, TileLayer, LayersControl, FeatureGroup, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import {Link} from 'react-router-dom'

function MapInsurance() {

    const [loading, setLoading]=useState(true)
    const [loadingsubmit, setLoadingsubmit]=useState(true)

    const [error, setError]=useState(false)
    const [message, setMessage]=useState('')

    const [sensorsoptions, setSensorsoptions] = useState([]);
    const [sensors, setSensor] = useState('');

    const [dateoptions, setDateoptions] = useState([]);
    const [date, setDate] = useState('');

    const [sensordata, setSensordata]=useState([])

    const [htmlmap, setHtmlmap]=useState('')

    const [variable, setVariable] = useState('count')

    const [max, setMax] = useState('')
    const [mean, setMean] = useState('')
    const [min, setMin] = useState('')

    const [loadingMAP, setLoadingMAP] = useState(false)
    const [loadingPLOT, setLoadingPLOT] = useState(false)

    const [htmlgraph, setHtmlgraph]=useState('')
    const [loadingsubmitrastermap, setLoadingsubmitrastermap]=useState(true)
    

    const token = useSelector((state) => state.userLogin.userInfo.token);

    ////////////
    const { t, i18n } = useTranslation();  

    useEffect(() => {
        const storedLanguage = localStorage.getItem('selectedLanguageAFS');
        if (storedLanguage) {
        i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);
    ////////////

    useEffect(() => {

        const fetchData = async () => {

            try {
                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
                
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/list-devices-insurance-operator/`, config);
                
                setSensorsoptions(response.data)

            } catch (error) {

            } finally {
                setLoading(false)
            }
        };

        fetchData(); 
    }, [token]);

    const handleSelectChange1 = async (e) => {
        
        setSensor(e.target.value)
        
        const sensorselected = e.target.value

        try {

            const config = {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            }
            
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/dates-devices-insurance-operator/${sensorselected}/`, config);
               
            setDateoptions(response.data);

        } catch (error) {

        }
    };

    const handleSelectChange2 = async (e) => {
        setDate(e.target.value)

        const dateselected = e.target.value

        try {

            const config = {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            }
            
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/data-devices-insurance-operator/${sensors}/${dateselected}`, config);
            
            setSensordata(response.data);

        } catch (error) {

        }

    }

    const redIcon = new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
    });

    const submit = async(e) => {
        
        setLoadingsubmit(false)
        setLoadingMAP(true)
        setLoadingPLOT(true)

        if (sensors==='') {
            setMessage(t('The sensor is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        } 

        if (date==='') {
            setMessage(t('The date is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        } 

        try {

            const config = {
                headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
                }
            }; 

            const response_statistics = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/statistics/${sensors}/${variable}/`, config);
            
            setMax(response_statistics.data.max)
            setMean(response_statistics.data.mean)
            setMin(response_statistics.data.min)
            
            const response_map = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/html-widget-map/${sensors}/${date}/${variable}/`, config);

            setHtmlmap(response_map.data)
            setLoadingMAP(false)

            const response_graph = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/html-widget-graph/${sensors}/${date}/${variable}/`, config);

            setHtmlgraph(response_graph.data)
            setLoadingPLOT(false)

        } catch (error) {
            setMessage(t("Some problems occured, please retry and if the problem persists please send an email to info@automaticfarmsolution.com"))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true)
            return;
        } finally {
            setLoadingsubmit(true)
        }

    }

    const submitdownloadinterpolatedmap = async (e) => {
        setLoadingsubmitrastermap(false);

        if (sensors === '' || date === '') {
            setMessage(t('The sensor or date is empty'));
            setError(true);
            setTimeout(() => setError(false), 5000);
            setLoadingsubmit(true);
            return;
        }

        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                responseType: 'blob'  // Imposta la risposta come Blob
            };

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/insurance/download-map/${sensors}/${date}/${variable}/`, config);

            // Crea un oggetto Blob con i dati binari della risposta
            const blob = new Blob([response.data], { type: 'application/zip' });

            // Crea un URL oggetto per il blob
            const url = window.URL.createObjectURL(blob);

            // Crea un link temporaneo
            const link = document.createElement('a');
            link.href = url;

            // Imposta il nome del file da scaricare
            link.setAttribute('download', 'FruitKountMap.zip');

            // Aggiunge il link al documento e simula un clic per avviare il download
            document.body.appendChild(link);
            link.click();

            // Rimuove il link temporaneo dal documento
            document.body.removeChild(link);

            // Rilascia l'URL dell'oggetto per il blob
            window.URL.revokeObjectURL(url);

        } catch (error) {
            setMessage(t("Some problems occurred, please retry."));
            setError(true);
            setTimeout(() => setError(false), 5000);
            setLoadingsubmitrastermap(true);
        } finally {
            setLoadingsubmitrastermap(true);
        }
    };

    return (
        <div>
            <Header/>
            {loading ? (
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Spinner>
                                {t('Loading')}
                            </Spinner>
                        </Col>
                    </Row>
                </Container>
            ):(
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="text-center mt-5">
                            <Card>
                                <CardHeader>
                                    <h3>{t('Analysis Setting')}</h3>
                                </CardHeader>
                                <CardBody>
                                    <Form>
                                        <Form.Group controlId="exampleForm.SelectCustom">
                                            <Form.Label>{t('Select the sensor')}</Form.Label>
                                            <Form.Control 
                                                as="select" 
                                                onChange={handleSelectChange1} 
                                                value={sensors}>
                                                    <option key={""} value={""}>
                                                        
                                                    </option>
                                                    {sensorsoptions.map((farmer, index) => (
                                                        <option key={index} value={farmer.id_sensor}>
                                                            {farmer.first_name} {farmer.last_name} {t('ID Sensor')}: {farmer.id_sensor}
                                                        </option>
                                                    ))}
                                            </Form.Control>
                                        </Form.Group> 
                                        <br></br>
                                        <Form.Group controlId="exampleForm.SelectCustom">
                                            <Form.Label>{t('Select the date')}</Form.Label>
                                            <Form.Control 
                                                as="select" 
                                                onChange={handleSelectChange2}
                                                value={date}>
                                                    <option key={""} value={""}>
                                                        
                                                    </option>
                                                    {dateoptions.map((farmer, index) => (
                                                        <option key={index} value={farmer.date}>
                                                            {format(new Date(farmer.date), 'PPpp')}
                                                        </option>
                                                    ))}
                                            </Form.Control>
                                        </Form.Group>                            
                                        <br></br>
                                        <Form.Group controlId="exampleForm.SelectCustom">
                                            <Form.Label>{t('Select variable to map')}</Form.Label>
                                            <Form.Control 
                                                as="select"
                                                value={variable}
                                                onChange={(e) => setVariable(e.target.value)}>
                                                <option value={"count"}>
                                                    {t('Count')}
                                                </option>
                                                <option value={"area"}>
                                                    {t('Area')}
                                                </option>
                                                <option value={"width"}>
                                                    {t('Width')}
                                                </option>
                                                <option value={"height"}>
                                                    {t('Height')}
                                                </option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Form>
                                </CardBody>
                                <CardFooter>
                                    <Row>
                                        {error && <Alert  color="danger" fade={false}>{message}</Alert >}
                                        {loadingsubmit ? (
                                            <>
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                                                    <Button color="success" onClick={submit}>
                                                        {t('Run analysis')} <i className="fa-solid fa-code"></i>
                                                    </Button>
                                                </Col>
                                            </>
                                        ) : (
                                            <>
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                                                    <Button color="success" disabled>
                                                        <Spinner size="sm">
                                                            {t('Loading')}
                                                        </Spinner>
                                                        <span>
                                                            {' '}{t('Loading')}
                                                        </span>
                                                    </Button>
                                                </Col>
                                            </>
                                        )}
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                                            <Link to="/">
                                                <Button color='primary'>
                                                    {t('Go back')} <i className="fas fa-rotate-left"></i>
                                                </Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardFooter>
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={9} xl={9} xxl={9} className="text-center mt-5">
                            {sensordata && sensordata.length>0 ? (
                                <>
                                    <Card>
                                        <CardHeader>
                                            <h3>{t('Data Points Location')}</h3>
                                        </CardHeader>
                                        <CardBody>
                                            <MapContainer key={sensordata[0].group_acquisition+sensordata[0].id} center={[sensordata[0].y_coord, sensordata[0].x_coord]} zoom={15} style={{ height: '500px', width: '100%', margin: 0, padding: 0 }}>
                                                <LayersControl position="topright">
                                                    <LayersControl.BaseLayer checked name="OpenStreetMap">
                                                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
                                                    </LayersControl.BaseLayer>
                                                    <LayersControl.BaseLayer checked name="Satellite">
                                                        <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" attribution='&copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community' />
                                                    </LayersControl.BaseLayer>
                                                </LayersControl>
                                                {sensordata.map((farmer, index) => (
                                                    <FeatureGroup key={index}>
                                                        <Marker position={[farmer.y_coord, farmer.x_coord]} icon={redIcon}>
                                                            <Popup>
                                                                <p>{t('Crop :')} {t(`translation:${farmer.crop}`)}</p>
                                                                <p>{t('Number of Grape :')} {farmer.count}</p>
                                                                <p>{t('Date Time of Data Acquisition :')} {format(new Date(farmer.date), 'PPpp')}</p>
                                                                {farmer.image1 ? <img src={farmer.image1} alt="Photo 1" style={{ height: '50%', width: '50%', objectFit: 'cover', cursor: 'pointer' }}/> : <p>No photo saved</p> }
                                                                {farmer.image2 ? <img src={farmer.image2} alt="Photo 2" style={{ height: '50%', width: '50%', objectFit: 'cover', cursor: 'pointer' }}/> : <p>No photo saved</p> }                                  
                                                            </Popup>
                                                        </Marker>
                                                    </FeatureGroup>
                                                ))}
                                            </MapContainer>
                                        </CardBody>
                                    </Card>
                                </>
                                ):null}
                        </Col>
                         {htmlmap && (
                            <>
                                <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="text-center mt-5">
                                    <Card className="card-stats mb-4 mb-xl-0">
                                        <CardBody>
                                            <Row>
                                                <div className="col">
                                                    <CardTitle
                                                        tag="h5"
                                                        className="text-uppercase text-muted mb-0">
                                                        {t('Max Value')}
                                                    </CardTitle>
                                                    <span className="h2 font-weight-bold mb-0">
                                                    {max && (
                                                        <>
                                                            {max}
                                                        </>
                                                    )}
                                                    </span>
                                                </div>
                                                <Col className="col-auto">
                                                    <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                                                        <i class="fa-solid fa-arrow-up-wide-short"></i>                                                    
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="text-center mt-5">
                                    <Card className="card-stats mb-4 mb-xl-0">
                                        <CardBody>
                                            <Row>
                                                <div className="col">
                                                    <CardTitle
                                                        tag="h5"
                                                        className="text-uppercase text-muted mb-0">
                                                        {t('Mean Value')}
                                                    </CardTitle>
                                                    <span className="h2 font-weight-bold mb-0">
                                                    {mean && (
                                                        <>
                                                            {mean}
                                                        </>
                                                    )}
                                                    </span>
                                                </div>
                                                <Col className="col-auto">
                                                    <div className="icon icon-shape bg-primary text-white rounded-circle shadow">
                                                        <i class="fa-solid fa-calculator"></i>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="text-center mt-5">
                                    <Card className="card-stats mb-4 mb-xl-0">
                                        <CardBody>
                                            <Row>
                                                <div className="col">
                                                    <CardTitle
                                                        tag="h5"
                                                        className="text-uppercase text-muted mb-0">
                                                        {t('Min Value')}
                                                    </CardTitle>
                                                    <span className="h2 font-weight-bold mb-0">
                                                    {min && (
                                                        <>
                                                            {min}
                                                        </>
                                                    )}
                                                    </span>
                                                </div>
                                                <Col className="col-auto">
                                                    <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                                                    <i class="fa-solid fa-1"></i>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
                                    <Card>
                                        <CardHeader>
                                            <h3>{t('Map')}</h3>
                                        </CardHeader>
                                        <CardBody>  
                                            {loadingMAP ? (
                                                <>
                                                    <Spinner></Spinner>
                                                </>
                                            ):(
                                                <>
                                                    <iframe id="iframe1" width="100%" height="400" srcDoc={htmlmap}></iframe>
                                                </>
                                            )}                                          
                                            {loadingsubmitrastermap ? (
                                                <>
                                                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                                                        <Button color="success" onClick={submitdownloadinterpolatedmap}>
                                                            {t('Download')} <i class="fa-solid fa-cloud-arrow-down"></i>
                                                        </Button>
                                                    </Col>
                                                </>
                                            ) : (
                                                <>
                                                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                                                        <Button color="success" disabled>
                                                            <Spinner size="sm">
                                                                {t('Downloading')}
                                                            </Spinner>
                                                            <span>
                                                                {' '}{t('Downloading')}
                                                            </span>
                                                        </Button>
                                                    </Col>
                                                </>
                                            )}                                                                          
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="text-center mt-5">
                                    <Card>
                                        <CardHeader>
                                            <h3>{t('Plot')}</h3>
                                        </CardHeader>
                                        <CardBody>
                                            {loadingPLOT ? (
                                                <>
                                                    <Spinner></Spinner>
                                                </>
                                            ):(
                                                <>
                                                    <iframe id="iframe2" width="100%" height="400" srcDoc={htmlgraph}></iframe>      
                                                </>
                                            )}                                                                                                                        
                                        </CardBody>
                                    </Card>
                                </Col>
                            </>
                         )}
                    </Row>
                </Container>
            )}
        </div>
    )
}

export default MapInsurance
